import TextField from "@/components/layouts/History/TextField";
import { useCompanySegments } from "@/pages/companies/hooks";
import { LookupNameFromIdx } from "@/utils/datamaps";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
}

const SegmentationName: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  const companySegments = useCompanySegments().data?.segments ?? [];
  const segmentName = LookupNameFromIdx(
    t,
    "companies.segmentValues",
    companySegments,
    Number(value)
  );
  return <TextField>{segmentName}</TextField>;
};

export default SegmentationName;
